import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterLink } from '@angular/router';
import { I18NEXT_SERVICE, I18NextModule, ITranslationService } from 'angular-i18next';
import { SearchResultsFilterablesService } from 'utils/search-results-filterable';
import { IconComponent } from '../../../common/icon/icon.component';
import { RouteTranslatePipe } from '../../pipes/route-translate.pipe';
import { ParamsService } from '../../../pages/search-results/params/params.service';
import { RouteTranslateService } from '../../../common/route-translate/route-translate.service';
import { BasePlusComponent } from '../base/base-plus.component';

@Component({
  selector: 'sharry-search-gallery',
  standalone: true,
  templateUrl: './search-gallery.component.html',
  styleUrl: './search-gallery.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, I18NextModule, RouterLink, RouteTranslatePipe, IconComponent],
})
export class SearchGalleryComponent extends BasePlusComponent {
  constructor(
    public searchResultsFilterablesService: SearchResultsFilterablesService,
    private paramsService: ParamsService,
    private router: Router,
    private routeTranslateService: RouteTranslateService,
    @Inject(I18NEXT_SERVICE) public translateService: ITranslationService,
  ) {
    super();
  }
  onNavigateTo(typesFilterables: string[]) {
    const queryParams = { types: typesFilterables };
    this.paramsService.setKindsFromUrlTypes(queryParams?.types);
    this.router.navigate([this.routeTranslateService.translateRoute('search-results')], {
      queryParams,
    });
  }
}
